import React, { useEffect } from "react";
import Question from "./Question";
import { useState } from "react";
import questionsManager from "../questionsmanager";
import useQuestionsData from "../hooks/useQuestionsData";


export default function QuestionsForm({ name, onSubmit }) {
    const { questions, productFinderHistoryId } = useQuestionsData(name);
    const [questionsList, setQuestionsList] = useState([]);
    const [isComplete, setIsComplete] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const managerRef = React.useRef(null);

    useEffect(() => {
        if (questions.length && !managerRef.current) {
            managerRef.current = questionsManager({
                id: productFinderHistoryId,
                questions: questions.map(question => {
                    question.QuestionDisplayText = question.QuestionDisplayText.replace(/\{0\}/gi, name);
                    return question;
                })
            });
            setQuestionsList(managerRef.current.list());
        }
    }, []);

    const update = (questionId, answer) => {
        if (!managerRef.current) {
            return;
        }

        managerRef.current.set(questionId, answer);

        const currentQuestions = managerRef.current.list();
        setQuestionsList(currentQuestions);
        setIsComplete(containQuestionsAndAnswers(currentQuestions));
    };


    const submit = async event => {
        event.preventDefault();

        if (isComplete && managerRef.current) {
            setIsSaving(true);

            const response = await managerRef.current.save(name);

            if (typeof onSubmit === 'function') {
                onSubmit(response.categories);
            }

            setIsSaving(false);
        }
    };

    if (!name) {
        return null;
    }

    return (
        <form id="questions-form" className="tsc-form" onSubmit={submit}>
            {questionsList.map(question => (
                <div className="question" key={question.QuestionId}>
                    <Question
                        question={question}
                        answers={question.Answers}
                        selectedAnswers={question.SelectedAnswers}
                        onChange={update}
                    />
                </div>
            ))}
            <div className="button-row">
                <input
                    className="tsc-button"
                    type="submit"
                    value="Find Recommendations"
                    disabled={!isComplete || isSaving}
                />
            </div>
        </form>
    );
}

function isNotEmptyArray(item) {
    return Array.isArray(item) && item.length > 0;
}

function containQuestionsAndAnswers(questions) {
    return isNotEmptyArray(questions) && questions.every(question => isNotEmptyArray(question.SelectedAnswers));
}

